import { AbstractBitBoardSet32 } from './AbstractBitBoardSet32';
import { BitBoardEntity } from '../../../utils/BitBoardEntity';


export class BitBoardBitSetForNext32 extends AbstractBitBoardSet32  {
    public allocate():number {
        throw new Error("This manager is for next, not allowed call.");
    }
    public allocateIds( length:number ):Array<number> {
        throw new Error("This manager is for next, not allowed call.");
    }

    private searchMinSetBit( height:number, bucketIdx:number ):number{
        var currentValue:number = this.longTree[height][bucketIdx];
        currentValue = BitBoardEntity.numberOfTrailingZeros( currentValue );
        var nextBucketIdx:number = -1;
        if( height < this.currentTreeLevel ){
            nextBucketIdx = ( bucketIdx << 5 ) + currentValue;
            return this.searchMinSetBit(height + 1, nextBucketIdx  );
        }else{
            nextBucketIdx = ( bucketIdx << 5 ) + currentValue;
            return nextBucketIdx;
        }
    }
    
     private nextSetBitInternal( height:number, id:number ):number{
        var currentBucket:number = id >> 5;
        var idx:number = id & AbstractBitBoardSet32.REST_MASK;
        var currentIdx:number = 1 << (idx);
        
        var currentValue:number = this.longTree[this.currentTreeLevel - height][ currentBucket];
        
        var newIdx:number = ~( currentIdx | ( currentIdx - 1 ) );
        newIdx &= currentValue;

        if( newIdx == 0 ){
            //go up
            if( height == this.currentTreeLevel ){
                return -1;
            }else{
                return this.nextSetBitInternal( height + 1, currentBucket);
            }
        }else{
            //go down
            currentIdx = BitBoardEntity.numberOfTrailingZeros(newIdx);
            if( height == 0 ){
                return (currentBucket << 5) + currentIdx;
            }
            //w dol pojdzie tylko numer bucketa, pozycja w tym buckecie sama sie zlilczy -> currentBucket
            var value:number = this.searchMinSetBit(this.currentTreeLevel - height + 1, (currentBucket << 5) + currentIdx);
            //TODO check range
            return value;
        }		
    }
    
    public nextSetBit( id:number ):number {
        if( this.isAllocated(id)){
            return id;
        }
        return this.nextSetBitInternal(0, id);
    }
    
    allocateConcreteInternal( height:number, id:number ):void {
        var currentBucket:number = id >> 5;
        var idx:number = id & AbstractBitBoardSet32.REST_MASK;
        var currentIdx:number = 1 << (idx);
        var emptyAtStart:Boolean = this.longTree[this.currentTreeLevel - height][ currentBucket] == 0;
        
        if( (~this.longTree[this.currentTreeLevel - height][currentBucket]) == 0 ){
            throw new Error("Trying to set value in full bucket.");
        }
        if( (this.longTree[this.currentTreeLevel - height][currentBucket] & currentIdx ) != 0 ){
            throw new Error("Trying to set the sema bit again.");
        }
        this.longTree[ this.currentTreeLevel - height ][ currentBucket ] |= currentIdx;
        if( emptyAtStart && height < this.currentTreeLevel ){
            this.allocateConcreteInternal( height + 1, currentBucket );
        }
    }
    
    public free( id:number ):void{
        if( id < 0 ){
            throw new Error("Id must be above 0, you try to free: " + id );
        }
        this.initialLoad = false;
        this.currentSize--;
        this.freeInternal( 0, id );
    }
    
    public freeInternal( height:number, id:number ):void{
        var currentBucket:number = (id >> 5);
        var idx:number = (id & AbstractBitBoardSet32.REST_MASK);
        var currentIdx:number = 1 << (idx);
        
        if( (this.longTree[this.currentTreeLevel - height][currentBucket] & currentIdx ) == 0 ){
            throw new Error("Trying to free bit that is not set: " + id + ", on level: " + ( this.currentTreeLevel - height) + ", with maxTreeLEvel: " + this.currentTreeLevel);
        }
        this.longTree[ this.currentTreeLevel - height ][ currentBucket ] &= ~currentIdx;
        var emptyAfterOperation:Boolean = this.longTree[this.currentTreeLevel - height][ currentBucket] == 0;
        if( emptyAfterOperation && height < this.currentTreeLevel ){
            this.freeInternal( height + 1, currentBucket );
        }
    }

    public toArray():Array<number> {
        let arr:Array<number> = new Array();
        let j:number = 0;
        for ( var i :number = this.nextSetBit( 0 ); i >= 0; i = this.nextSetBit( i + 1 ) ) {
            arr[ j++ ] = i;
        }
        return arr;
    }
}